import { MessageDescriptor } from 'react-intl';

import partnerMessages from '../configs/Partnerships/messages';

/** Selects the standard partnership/campaign terms copy for a trial and/or discount offer. */
export function selectStandardOfferTerms(hasTrial: boolean, hasDiscount: boolean): MessageDescriptor {
	if (hasTrial) return partnerMessages.loginSignupTerms;
	return hasDiscount
		? partnerMessages.loginSignupTerms_noTrial
		: partnerMessages.loginSignupTerms_noTrial_noPromo;
}
